import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import DataSvc from "../../../services/dataSvc";

export type LocationSelectQueryParams = {
  locationName?: string;
  organizationId?: string;
};

export const useLocationSelect = () => {
  const [queryParams, setQueryParams] = useState<LocationSelectQueryParams>({
    organizationId: undefined,
    locationName: undefined,
  });
  const { data: locations, isLoading: isLoadingLocations } = useQuery({
    queryKey: ["locations", queryParams],
    queryFn: () =>
      DataSvc.getLocations({
        summary_mode: true,
        limit: 100000,
        organization_id: queryParams.organizationId
          ? [queryParams.organizationId]
          : undefined,
        query: queryParams.locationName,
      }),
  });

  const { data: organizations, isLoading: isLoadingOrganizations } = useQuery(
    ["organizations"],
    () => DataSvc.getOrganizations({ limit: 100000 })
  );

  const changeQueryParams = (params: Partial<LocationSelectQueryParams>) => {
    setQueryParams((prev) => ({ ...prev, ...params }));
  };

  return {
    locations: locations?.list ?? [],
    organizations: organizations?.list ?? [],
    changeQueryParams,
    queryParams,
    isLoadingLocations,
    isLoadingOrganizations,
  };
};
